(() => {
	$('.popular-course-slider').each(function (i, el) {
		let swiperClass = 'popular-course-slider-' + i;
		$(this).addClass(swiperClass);

		// navigation
		let prevClass = 'popular-course-button-prev-' + i;
		let nextClass = 'popular-course-button-next-' + i;
		$(this).parent().find('.swiper-button-prev').addClass(prevClass);
		$(this).parent().find('.swiper-button-next').addClass(nextClass);

		new Swiper('.' + swiperClass, {
			loop: false,
			speed: 500,
			slidesPerView: 'auto',
			spaceBetween: 16,
			centerInsufficientSlides: false,
			watchOverflow: true,
			freeMode: {
				enabled: true,
				sticky: true
			},
			navigation: {
				prevEl: '.' + prevClass,
				nextEl: '.' + nextClass
			},
			breakpoints: {
				992: {
					slidesPerView: 3,
					spaceBetween: 24
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 48
				}
			}
		});
	});
})();
